import { render, staticRenderFns } from "./CompanyDocumentPage.vue?vue&type=template&id=15b3ee28&scoped=true&"
import script from "./CompanyDocumentPage.vue?vue&type=script&lang=js&"
export * from "./CompanyDocumentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3ee28",
  null
  
)

export default component.exports